import api from "../axios";

export const vendorLogin = (data) => api.post("auth/vendor/login", data);
export const VendorRegister = (data) => api.post("auth/vendor/register", data);
export const vendorLogout = (data) => api.post("auth/vendor/logout", data);
export const ClientRegister = (data) => api.post("auth/user/register", data);
export const ClientLogin = (data) => api.post("auth/user/login", data);
export const resendVerificationLink = (data) =>
  api.post("auth/user/resend-verification-link", data);
export const ClientGoogleLogin = (data) =>
  api.post("auth/user/googlelogin", data);
export const AppClientGoogleLogin = (data) =>
  api.post("auth/user/app/googlelogin", data);
export const vendorGoogleLogin = (data) =>
  api.post("auth/vendor/googlelogin", data);
export const ClienVerify = (data) =>
  api.patch(`auth/user/verify/${data}`, data);
export const VendorVerify = (data) =>
  api.patch(`auth/vendor/verify/${data}`, data);
export const clientLogout = (data) => api.post("auth/user/logout", data);
export const SendVerificationLink = (data) =>
  api.patch("auth/user/forget-password/send-mail", data);
export const SendForgetPasswordMail = (data) =>
  api.patch("auth/vendor/forget-password/send-mail", data);
export const resetUserPassword = (data) =>
  api.patch("auth/user/reset-password", data);
export const resetVendorPassword = (data) =>
  api.patch(`auth/vendor/reset-password/${data}`, data);
export const AppClientAppleSignIn = (data) =>
  api.post("auth/user/ios/login", data);
export const googleLogin = (data) => api.post("auth/google/callback", data);
export const facebookLogin = (data) =>
  api.post("auth/user/facebook/login", data);
export const vendorFacebookLogin = (data) =>
  api.post("auth/vendor/facebook/login", data);
export const VendorResendVerificationLink = (data) =>
  api.post("auth/vendor/resend-verification-link", data);
export const addToCalender = (data) =>
  api.post("auth/google/addToCalender", data);
